"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialCodeToJSON = exports.DialCodeFromJSONTyped = exports.DialCodeFromJSON = void 0;
function DialCodeFromJSON(json) {
    return DialCodeFromJSONTyped(json, false);
}
exports.DialCodeFromJSON = DialCodeFromJSON;
function DialCodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'dialCode': json['dialCode'],
        'code': json['code'],
        'flag': json['flag'],
    };
}
exports.DialCodeFromJSONTyped = DialCodeFromJSONTyped;
function DialCodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'dialCode': value.dialCode,
        'code': value.code,
        'flag': value.flag,
    };
}
exports.DialCodeToJSON = DialCodeToJSON;
